<!--
 * @Descripttion: 
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-08-10 14:35:33
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-11-30 09:18:47
-->
<template>
    <div class="servicePerformance">
        <div class="title-wrap">
            <div class="tag"></div>
            <div class="title">客服绩效</div>
        </div>
        <div class="case-wrap">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="绩效列表" name="first">
                    <performanceList ref="performanceList"></performanceList>
                </el-tab-pane>
                <el-tab-pane label="绩效说明" name="second">
                    <performanceExplain ref="performanceExplain"></performanceExplain>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import performanceList from './goldComponents/performanceList'
import performanceExplain from './goldComponents/performanceExplain'
import pageMixin from '@/internal/pageMixin'
export default {
    components:{
        performanceList,
        performanceExplain,
    },
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'servicePerformance',
            activeName: 'first',
        }
    },
    mounted () {

    },
    methods: {

    },
}
</script>

<style lang='scss'>
.servicePerformance{
    background: rgb(240, 242, 245);
    padding: 10px 25px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    .title-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 5px 0;
        .tag{
            width: 4px;
            height: 20px;
            background: #409EFF;
            border-radius: 10px;
        }
        .title{
            font-size: 18px;
            font-weight: bold;
            padding-left: 10px;
        }
    }
    .case-wrap{
        background: #fff;
        padding: 20px;
        margin: 20px 0;
        border-radius: 6px;
    }
}
</style>
